import { arrDeduplication, getAxisOpt } from './tool';
/**
 * 柱状图
 * @param winChartProps
 * @returns
 */
export const getColumnOpt = (winChartProps) => {
    const barTypeList = arrDeduplication(winChartProps.data?.map((item) => item.type));
    return {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                label: {
                    backgroundColor: '#999',
                },
            },
        },
        legend: {
            bottom: 0,
            type: 'scroll',
        },
        xAxis: {
            ...getAxisOpt(winChartProps),
            axisPointer: {
                type: 'shadow',
            },
        },
        yAxis: {
            min: winChartProps.yStart?.[0],
        },
        series: barTypeList.map((name) => {
            return {
                name,
                type: 'bar',
                barGap: '30%',
                barCategoryGap: '30%',
                barMaxWidth: 8,
                data: winChartProps.data
                    ?.filter((item) => item.type === name)
                    .map((item) => ({
                    value: item.value,
                    itemStyle: {
                        borderRadius: item.value > 0 ? [500, 500, 0, 0] : [0, 0, 500, 500],
                    },
                })),
            };
        }),
    };
};
/**
 * 堆叠柱状图
 * @param winChartProps
 * @returns
 */
export const getColumnStackOpt = (winChartProps) => {
    const barTypeList = arrDeduplication(winChartProps.data?.map((item) => item.type));
    return {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                label: {
                    backgroundColor: '#999',
                },
            },
        },
        legend: {
            bottom: 0,
            type: 'scroll',
        },
        xAxis: {
            ...getAxisOpt(winChartProps),
            axisPointer: {
                type: 'shadow',
            },
        },
        yAxis: {
            min: winChartProps.yStart?.[0],
        },
        series: barTypeList.map((name) => {
            return {
                name,
                type: 'bar',
                stack: 'total',
                barGap: '30%',
                barCategoryGap: '30%',
                barMaxWidth: 8,
                data: winChartProps.data
                    ?.filter((item) => item.type === name)
                    .map((item) => ({
                    value: item.value,
                })),
            };
        }),
    };
};
